import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
// This Module's Components
import { AppSecondaryLinksContentComponent } from './app-secondary-links-content.component';

@NgModule({
  imports: [CommonModule, DataLayerModule],
  declarations: [AppSecondaryLinksContentComponent],
  exports: [AppSecondaryLinksContentComponent]
})
export class AppSecondaryLinksContentModule {}
